type Props = {
  /** Roundel diameter in px. */
  size?: number;
  /** Wordmark + tagline sit beside the roundel unless this is false. */
  showWordmark?: boolean;
  /** Dark grounds get white type; light grounds get ink. */
  tone?: 'light' | 'dark';
  className?: string;
};

const LOGO_IMAGE_URL =
  'https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/88239fe1-d299-408c-8199-9a47a84d90e7/1787073979186-77xdic.png';

/**
 * Brand mascot logo image + "Yalla Eat" wordmark.
 */
export default function Logo({ size = 46, showWordmark = true, tone = 'dark', className = '' }: Props) {
  const onDark = tone === 'dark';
  return (
    <span className={`flex items-center gap-2 sm:gap-3 min-w-0 ${className}`} data-hs-id="logo">
      <img
        src={LOGO_IMAGE_URL}
        alt="Yalla Eat logo"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
      />

      {showWordmark && (
        <span className="flex flex-col leading-none min-w-0">
          <span className="display text-lg sm:text-xl md:text-2xl whitespace-nowrap">
            <span style={{ color: onDark ? 'var(--color-yellow)' : 'var(--color-ink)' }}>YALLA</span>{' '}
            <span style={{ color: onDark ? 'var(--color-yellow)' : 'var(--color-ink)' }}>EAT</span>
          </span>
          <span
            className="mt-1 hidden min-[360px]:block truncate text-[9px] md:text-[10px] font-semibold uppercase tracking-[0.18em]"
            style={{ color: onDark ? 'rgba(255,255,255,0.6)' : 'var(--color-ink-2)' }}
          >
            Delicious. Fresh. Halal.
          </span>
        </span>
      )}
    </span>
  );
}
